// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1g22S","ranges":"BmiRanges_ranges__2QpGX"};